import { render, staticRenderFns } from "./FxRateMonitor.vue?vue&type=template&id=0bc7fb0d&scoped=true&"
import script from "./FxRateMonitor.vue?vue&type=script&lang=js&"
export * from "./FxRateMonitor.vue?vue&type=script&lang=js&"
import style0 from "./FxRateMonitor.vue?vue&type=style&index=0&id=0bc7fb0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc7fb0d",
  null
  
)

export default component.exports